import { useState, useEffect } from "react";

export default function LandingPage({ onGetStarted }) {
  const [scrolled, setScrolled] = useState(false);
  const [billingYearly, setBillingYearly] = useState(false);

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", fn, { passive: true });
    return () => window.removeEventListener("scroll", fn);
  }, []);

  const detectCurrency = () => {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || "";
    const lang = navigator.language || "";
    if (tz.includes("Kolkata") || tz.includes("Calcutta") || tz.includes("Rangoon") || tz.includes("Yangon") || lang.startsWith("my"))
      return { symbol: "₹", individual: "119", individual_y: "95", student: "59", student_y: "47", artist: "299", artist_y: "239", label: "INR" };
    if (tz.includes("London") || lang.startsWith("en-GB"))
      return { symbol: "£", individual: "10.99", individual_y: "8.79", student: "5.99", student_y: "4.79", artist: "13.99", artist_y: "11.19", label: "GBP" };
    if (tz.includes("Europe") || lang.startsWith("de") || lang.startsWith("fr"))
      return { symbol: "€", individual: "10.99", individual_y: "8.79", student: "5.99", student_y: "4.79", artist: "13.99", artist_y: "11.19", label: "EUR" };
    if (tz.includes("Seoul") || lang.startsWith("ko"))
      return { symbol: "₩", individual: "13,900", individual_y: "11,100", student: "6,900", student_y: "5,500", artist: "17,900", artist_y: "14,300", label: "KRW" };
    if (tz.includes("Tokyo") || lang.startsWith("ja"))
      return { symbol: "¥", individual: "980", individual_y: "784", student: "480", student_y: "384", artist: "1,280", artist_y: "1,024", label: "JPY" };
    return { symbol: "$", individual: "9.99", individual_y: "7.99", student: "4.99", student_y: "3.99", artist: "14.99", artist_y: "11.99", label: "USD" };
  };

  const C = detectCurrency();

  const plans = [
    {
      name: "Free",
      price: "0",
      period: "",
      desc: "Start listening today.",
      featured: false,
      features: ["Unlimited streaming", "Search & discover", "Playlists & likes", "Social feed", "Basic karaoke", "Ad-supported"],
      cta: "Get started",
    },
    {
      name: "Individual",
      price: billingYearly ? C.individual_y : C.individual,
      period: "/mo",
      desc: "The full experience.",
      featured: true,
      features: ["Everything in Free", "No ads", "Offline listening", "HD audio", "Priority Music ID", "Member badge"],
      cta: "Get started",
    },
    {
      name: "Student",
      price: billingYearly ? C.student_y : C.student,
      period: "/mo",
      desc: "Full access, half price.",
      featured: false,
      features: ["Everything in Individual", "Student email required", "Renews annually"],
      cta: "Verify & save",
    },
    {
      name: "Artist Pro",
      price: billingYearly ? C.artist_y : C.artist,
      period: "/mo",
      desc: "Built for creators.",
      featured: false,
      features: ["Everything in Individual", "Upload unlimited tracks", "Analytics dashboard", "Featured in Discover", "Artist Music ID", "Fan messaging"],
      cta: "Start creating",
    },
  ];

  return (
    <div style={{ background: "#fff", color: "#000", fontFamily: "'DM Sans', sans-serif", minHeight: "100vh", overflowX: "hidden" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Instrument+Serif:ital@0;1&family=DM+Sans:wght@300;400;500;600&display=swap');
        *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }
        html { scroll-behavior: smooth; }
        ::-webkit-scrollbar { width: 3px; }
        ::-webkit-scrollbar-thumb { background: #000; }
        .serif { font-family: 'Instrument Serif', serif; }
        .serif-i { font-family: 'Instrument Serif', serif; font-style: italic; }
        .sl { font-size: 11px; font-weight: 600; letter-spacing: 0.14em; text-transform: uppercase; color: #999; margin-bottom: 12px; }
        .btn-d { background: #000; color: #fff; border: none; padding: 13px 26px; border-radius: 2px; font-family: 'DM Sans', sans-serif; font-size: 14px; font-weight: 500; cursor: pointer; transition: opacity 0.2s; letter-spacing: 0.02em; }
        .btn-d:hover { opacity: 0.75; }
        .btn-o { background: transparent; color: #000; border: 1px solid #000; padding: 13px 26px; border-radius: 2px; font-family: 'DM Sans', sans-serif; font-size: 14px; cursor: pointer; transition: all 0.2s; letter-spacing: 0.02em; }
        .btn-o:hover { background: #000; color: #fff; }
        @keyframes ticker { 0%{transform:translateX(0)} 100%{transform:translateX(-50%)} }
        @keyframes fadeUp { from{opacity:0;transform:translateY(20px)} to{opacity:1;transform:translateY(0)} }
        @keyframes eq0{from{height:6px}to{height:3px}}
        @keyframes eq1{from{height:12px}to{height:6px}}
        @keyframes eq2{from{height:8px}to{height:12px}}
        @keyframes eq3{from{height:14px}to{height:5px}}
        @keyframes eq4{from{height:5px}to{height:10px}}
        .fade-up { animation: fadeUp 0.7s ease both; }
        .plan-scroll { display: flex; gap: 12px; overflow-x: auto; padding-bottom: 8px; -webkit-overflow-scrolling: touch; scrollbar-width: none; }
        .plan-scroll::-webkit-scrollbar { display: none; }
        .plan-card { flex-shrink: 0; width: 240px; border: 1px solid #e5e5e5; border-radius: 4px; padding: 24px 20px; display: flex; flex-direction: column; }
        .plan-card.feat { background: #000; color: #fff; border-color: #000; }
        .feat-row { display: flex; align-items: flex-start; gap: 16px; padding: 20px 0; border-bottom: 1px solid #f5f5f5; }
        @media (max-width: 640px) {
          .nav-links { display: none !important; }
          .hero-grid { grid-template-columns: 1fr !important; }
          .hero-card { display: none !important; }
          .stat-grid { grid-template-columns: 1fr 1fr !important; gap: 16px !important; }
          .two-col { grid-template-columns: 1fr !important; gap: 32px !important; }
          .artist-grid { grid-template-columns: 1fr 1fr !important; }
          .footer-inner { flex-direction: column !important; align-items: flex-start !important; gap: 16px !important; }
          .plan-desktop { display: none !important; }
          .plan-mobile { display: block !important; }
          .pricing-header { flex-direction: column !important; align-items: flex-start !important; gap: 16px !important; }
        }
        @media (min-width: 641px) {
          .plan-mobile { display: none !important; }
          .plan-desktop { display: grid !important; }
        }
      `}</style>

      {/* NAV */}
      <nav style={{ position: "fixed", top: 0, left: 0, right: 0, zIndex: 100, height: 56, padding: "0 24px", display: "flex", alignItems: "center", justifyContent: "space-between", background: scrolled ? "rgba(255,255,255,0.96)" : "transparent", borderBottom: scrolled ? "1px solid #f0f0f0" : "none", backdropFilter: scrolled ? "blur(12px)" : "none", transition: "all 0.25s" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <img src="/logo192.png" alt="MyMusic" style={{ width: 32, height: 32, borderRadius: "50%", objectFit: "cover" }} />
          <span style={{ fontWeight: 600, fontSize: 15, letterSpacing: "-0.02em" }}>MyMusic</span>
        </div>
        <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
          <button onClick={onGetStarted} className="btn-o" style={{ padding: "8px 18px", fontSize: 13 }}>Sign in</button>
          <button onClick={onGetStarted} className="btn-d" style={{ padding: "8px 18px", fontSize: 13 }}>Join free</button>
        </div>
      </nav>

      {/* HERO */}
      <div style={{ maxWidth: 1100, margin: "0 auto", padding: "96px 24px 64px" }}>
        <div className="hero-grid" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 48, alignItems: "center" }}>
          <div className="fade-up">
            <p className="sl">Music for everyone</p>
            <h1 className="serif" style={{ fontSize: "clamp(40px, 7vw, 68px)", lineHeight: 1.05, letterSpacing: "-0.03em", marginBottom: 20 }}>
              Where music<br />becomes <span className="serif-i">connection.</span>
            </h1>
            <p style={{ fontSize: 16, color: "#777", lineHeight: 1.7, marginBottom: 32, maxWidth: 400 }}>
              Stream, upload, connect. Your Music ID. One platform for listeners and artists worldwide.
            </p>
            <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
              <button onClick={onGetStarted} className="btn-d" style={{ fontSize: 15, padding: "15px 30px" }}>Start for free</button>
              <button onClick={onGetStarted} className="btn-o" style={{ fontSize: 15, padding: "15px 30px" }}>See plans</button>
            </div>
         <p style={{ marginTop: 14, fontSize: 12, color: "#ccc" }}>Music for everyone, everywhere</p>
          </div>

          {/* Player card */}
          <div className="hero-card fade-up" style={{ background: "#000", borderRadius: 10, padding: 24, color: "#fff" }}>
            <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 20 }}>
              <div style={{ width: 6, height: 6, borderRadius: "50%", background: "#22c55e" }} />
              <span style={{ fontSize: 11, color: "#555", letterSpacing: "0.08em", fontWeight: 500 }}>LIVE WORLDWIDE</span>
            </div>
            {[
              { title: "Blinding Lights", artist: "The Weeknd", active: true },
              { title: "As It Was", artist: "Harry Styles", active: false },
              { title: "Lay Phyu — အေးငြိမ်း", artist: "Iron Cross", active: false },
              { title: "Dynamite", artist: "BTS", active: false },
            ].map((t, i) => (
              <div key={i} style={{ display: "flex", alignItems: "center", gap: 12, padding: "12px 0", borderBottom: "1px solid #111" }}>
                <div style={{ width: 32, height: 32, borderRadius: 4, background: t.active ? "#fff" : "#1a1a1a", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                  <svg viewBox="0 0 24 24" style={{ width: 11, height: 11, fill: t.active ? "#000" : "#444" }}><polygon points="5 3 19 12 5 21 5 3"/></svg>
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: 13, fontWeight: t.active ? 600 : 400, color: t.active ? "#fff" : "#555", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{t.title}</div>
                  <div style={{ fontSize: 11, color: "#444", marginTop: 2 }}>{t.artist}</div>
                </div>
                {t.active && (
                  <div style={{ display: "flex", gap: 2, alignItems: "flex-end", height: 14, flexShrink: 0 }}>
                    {[6, 12, 8, 14, 5].map((h, j) => (
                      <div key={j} style={{ width: 3, height: h, background: "#fff", borderRadius: 1, animation: `eq${j} 0.8s ease infinite alternate` }} />
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* TICKER */}
      <div style={{ overflow: "hidden", borderTop: "1px solid #f0f0f0", borderBottom: "1px solid #f0f0f0", padding: "12px 0" }}>
        <div style={{ display: "inline-block", animation: "ticker 24s linear infinite", whiteSpace: "nowrap" }}>
          {["Stream Music", "Upload Songs", "Music ID", "Communities", "Karaoke", "Live Charts", "Artist Profiles", "Beat Maker", "Global", "150+ Countries",
            "Stream Music", "Upload Songs", "Music ID", "Communities", "Karaoke", "Live Charts", "Artist Profiles", "Beat Maker", "5 Languages", "150+ Countries"].map((item, i) => (
            <span key={i} style={{ display: "inline-block", padding: "0 20px", fontSize: 12, fontWeight: 500, letterSpacing: "0.08em", color: i % 2 === 0 ? "#000" : "#ccc" }}>
              {item}{i % 5 === 4 ? " ✦" : " ·"}
            </span>
          ))}
        </div>
      </div>

      {/* STATS */}
      <div style={{ maxWidth: 1100, margin: "0 auto", padding: "64px 24px" }}>
        <div className="stat-grid" style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 24, borderTop: "1px solid #f0f0f0", paddingTop: 40 }}>
          {[["90M+", "Songs"], ["150+", "Countries"], ["PWA", "Any device"], ["Free", "To start"]].map(([val, label]) => (
            <div key={label}>
              <div className="serif" style={{ fontSize: "clamp(28px, 4vw, 44px)", letterSpacing: "-0.03em", marginBottom: 4 }}>{val}</div>
              <div style={{ fontSize: 12, color: "#999", letterSpacing: "0.06em", textTransform: "uppercase" }}>{label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* WHAT WE ARE */}
      <div style={{ borderTop: "1px solid #f0f0f0", padding: "64px 24px" }}>
        <div style={{ maxWidth: 1100, margin: "0 auto" }}>
          <p className="sl">What is MyMusic</p>
          <p className="serif" style={{ fontSize: "clamp(22px, 3.5vw, 36px)", lineHeight: 1.5, maxWidth: 700, color: "#000" }}>
            Not just another streaming app. A place where <span className="serif-i">listeners, artists and communities</span> meet. Stream, create, connect — and carry your Music ID as a real part of who you are.
          </p>
        </div>
      </div>

      {/* FEATURES */}
      <div style={{ maxWidth: 1100, margin: "0 auto", padding: "0 24px 64px", borderTop: "1px solid #f0f0f0" }}>
        <div style={{ paddingTop: 40, marginBottom: 8 }}><p className="sl">Everything included</p></div>
        {[
          { num: "01", title: "Stream & Discover", desc: "Millions of songs. Charts, genres, Myanmar music, recommendations." },
          { num: "02", title: "Upload Your Music", desc: "Artists upload directly. Build a following in 150+ countries." },
          { num: "03", title: "Social & Community", desc: "Follow artists, share music, join communities, message fans." },
          { num: "04", title: "Universal Music Society ID", desc: "Apply for your official Music ID. More than a username — it's your global music identity." },
          { num: "05", title: "Create & Play", desc: "Beat maker, virtual piano, karaoke, lyrics, chord analysis." },
          { num: "06", title: "Everywhere", desc: "Web, mobile, PWA. Works on any device in 5 languages." },
        ].map((f, i) => (
          <div key={i} className="feat-row">
            <span style={{ fontSize: 11, color: "#ccc", fontWeight: 500, minWidth: 24, marginTop: 3 }}>{f.num}</span>
            <div>
              <div style={{ fontSize: 15, fontWeight: 600, marginBottom: 4, letterSpacing: "-0.01em" }}>{f.title}</div>
              <div style={{ fontSize: 13, color: "#888", lineHeight: 1.65 }}>{f.desc}</div>
            </div>
          </div>
        ))}
      </div>

      {/* MUSIC ID */}
      <div style={{ background: "#f9f9f9", padding: "64px 24px", borderTop: "1px solid #f0f0f0" }}>
        <div style={{ maxWidth: 1100, margin: "0 auto" }}>
          <div className="two-col" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 60, alignItems: "center" }}>
            <div>
              <p className="sl">Universal Music Society</p>
              <h2 className="serif" style={{ fontSize: "clamp(28px, 4vw, 48px)", lineHeight: 1.1, letterSpacing: "-0.03em", marginBottom: 16 }}>
                Your Music ID.<br /><span className="serif-i">Your identity.</span>
              </h2>
              <p style={{ fontSize: 14, color: "#777", lineHeight: 1.75, marginBottom: 24 }}>
                Apply for membership. Get reviewed. Receive your official MUS-XXXX-XXXXXX ID and join a global music community.
              </p>
              <button onClick={onGetStarted} className="btn-d">Apply for membership</button>
            </div>
            <div style={{ background: "#000", borderRadius: 10, padding: 28, color: "#fff", maxWidth: 300 }}>
              <div style={{ fontSize: 9, color: "#444", letterSpacing: "0.16em", fontWeight: 600, marginBottom: 20, textTransform: "uppercase" }}>Universal Music Society · Official Member</div>
              <div style={{ width: 44, height: 44, borderRadius: "50%", background: "#111", border: "1px solid #222", display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 14 }}>
                <svg viewBox="0 0 24 24" style={{ width: 18, height: 18, fill: "none", stroke: "#fff", strokeWidth: 1.5 }}><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
              </div>
              <div className="serif" style={{ fontSize: 20, marginBottom: 4 }}>@yourusername</div>
              <div style={{ fontSize: 11, color: "#444", fontFamily: "monospace", marginBottom: 20 }}>MUS-2026-492817</div>
              <div style={{ display: "flex", justifyContent: "space-between", paddingTop: 16, borderTop: "1px solid #111" }}>
                <div><div style={{ fontSize: 9, color: "#444", marginBottom: 3, textTransform: "uppercase" }}>Type</div><div style={{ fontSize: 12, fontWeight: 500 }}>Music Lover</div></div>
                <div style={{ textAlign: "right" }}><div style={{ fontSize: 9, color: "#444", marginBottom: 3, textTransform: "uppercase" }}>Since</div><div style={{ fontSize: 12, fontWeight: 500 }}>2026</div></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      
      {/* FOR ARTISTS */}
      <div style={{ background: "#000", color: "#fff", padding: "64px 24px", borderTop: "1px solid #111" }}>
        <div style={{ maxWidth: 1100, margin: "0 auto" }}>
          <div className="two-col" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 48, alignItems: "center" }}>
            <div>
              <p style={{ fontSize: 11, fontWeight: 600, letterSpacing: "0.14em", color: "#555", marginBottom: 12, textTransform: "uppercase" }}>For Artists</p>
              <h2 className="serif" style={{ fontSize: "clamp(28px, 4vw, 44px)", lineHeight: 1.1, letterSpacing: "-0.03em", marginBottom: 16 }}>
                Your music.<br /><span className="serif-i">Your audience.</span>
              </h2>
              <p style={{ fontSize: 14, color: "#666", lineHeight: 1.75, marginBottom: 28 }}>
                Upload free. Reach listeners in 150+ countries. No gatekeepers.
              </p>
              <button onClick={onGetStarted} style={{ background: "#fff", color: "#000", border: "none", padding: "13px 26px", borderRadius: 2, fontSize: 14, fontWeight: 600, cursor: "pointer" }}>
                Start uploading free →
              </button>
            </div>
            <div className="artist-grid" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 1, background: "#1a1a1a", borderRadius: 6, overflow: "hidden" }}>
              {[["↑", "Upload", "Any format"], ["◎", "Reach", "150+ countries"], ["♡", "Connect", "Build fans"], ["✦", "ID", "Artist badge"]].map(([icon, label, desc], i) => (
                <div key={i} style={{ background: "#111", padding: "20px 16px" }}>
                  <div style={{ fontSize: 18, marginBottom: 10, color: "#fff" }}>{icon}</div>
                  <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 4, color: "#fff" }}>{label}</div>
                  <div style={{ fontSize: 11, color: "#555" }}>{desc}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* FINAL CTA */}
      <div style={{ padding: "80px 24px", textAlign: "center", borderTop: "1px solid #f0f0f0" }}>
        <p className="sl" style={{ textAlign: "center" }}>Get started today</p>
        <h2 className="serif" style={{ fontSize: "clamp(32px, 6vw, 60px)", lineHeight: 1.05, letterSpacing: "-0.04em", marginBottom: 16, maxWidth: 600, margin: "0 auto 16px" }}>
          The world's music<br /><span className="serif-i">is waiting for you.</span>
        </h2>
        <p style={{ fontSize: 15, color: "#999", marginBottom: 36, maxWidth: 340, margin: "0 auto 36px", lineHeight: 1.7 }}>
          Join listeners and artists from 150+ countries. Free to start.
        </p>
        <button onClick={onGetStarted} className="btn-d" style={{ fontSize: 15, padding: "16px 40px" }}>Create your free account</button>
       <p style={{ marginTop: 14, fontSize: 12, color: "#ccc" }}>Music for everyone, everywhere</p>
      </div>

      {/* FOOTER */}
      <div style={{ borderTop: "1px solid #f0f0f0", padding: "24px" }}>
        <div className="footer-inner" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", maxWidth: 1100, margin: "0 auto" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <div style={{ width: 22, height: 22, background: "#000", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center" }}>
              <svg viewBox="0 0 24 24" style={{ width: 10, height: 10, fill: "#fff" }}><path d="M9 18V5l12-2v13"/><circle cx="6" cy="18" r="3"/><circle cx="18" cy="16" r="3"/></svg>
            </div>
            <span style={{ fontSize: 13, fontWeight: 600 }}>MyMusic</span>
          </div>
          <p style={{ fontSize: 12, color: "#bbb" }}>© 2026 MyMusic · Universal Music Society</p>
          <div style={{ display: "flex", gap: 20 }}>
          {[
  { label: "Terms", url: "/#terms" },
  { label: "Privacy", url: "/#privacy" },
  { label: "About", url: "/#about" }
].map(l => (
  <a key={l.label} href={l.url} style={{ fontSize: 12, color: "#bbb", cursor: "pointer", textDecoration: "none" }}>{l.label}</a>
))}
          </div>
        </div>
      </div>
    </div>
  );
}